// profileExtension.ts
import { clientConnector } from '@games/socket-client'

type ProfileCallback = (error: string | null, response: unknown) => void

/**
 * Расширяет clientConnector для работы с комнатами
 */
export function extendSocketWithSettings(): void {
  // Регистрируем один компонент со всеми методами комнаты
  const settingsComponent = {
    name: 'settings',
    methods: {
      // Методы для прослушивания событий от сервера
      onGlobalSettingsReceived: {
        listenEvent: 'settings:onGlobalSettingsReceived',
        responseMethodName: 'onGlobalSettingsReceived'
      },
    }
  }

  // Регистрируем компонент без возврата результата
  clientConnector.registerComponent(settingsComponent);
}